import { e社員区分 } from "../../constant/enum/syain"
import { e部所権限コード, 権限コード } from "../../constant/kengenCode"
import { TLoginUserInfo } from "../../service/auth/TAuth"

/**
 * 車輌所属画面の車輌異動ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 車輌異動ボタンの権限判定 = (userInfo: TLoginUserInfo) => {
  let 権限 = false
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case 権限コード.車輌マスタ登録.安全:
    case 権限コード.車輌マスタ登録.車輌:
    case 権限コード.車輌マスタ登録.本営:
    case 権限コード.車輌マスタ登録.大川:
    case 権限コード.車輌マスタ登録.金彰:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.事務員:
    case e社員区分.事務員管理職:
    case e社員区分.運行部員管理職:
    case e社員区分.役員:
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  if (has部所権限 && has社員区分権限) {
    権限 = true
  }

  // 読取専用フラグとして返却する
  return !権限
}

/**
 * 備品在庫一覧画面の削除ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 備品在庫削除ボタンの権限判定 = (userInfo: TLoginUserInfo) => {
  let 権限 = false
  let has社員区分権限

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 使用権限を設定
  if (has社員区分権限) {
    権限 = true
  }

  // 使用権限として返却する
  return 権限
}

/**
 * 有休管理画面の有休付与と変更ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 有休管理画面の有休付与と変更ボタンの使用権限判定 = (
  userInfo: TLoginUserInfo
) => {
  // KAIROS-1116: 人事経理の運行部員管理職(区分25)は有休付与・保有数変更の特権を持たない
  // （閲覧のみ。ビジネスルール「有休付与・残日数変更は人事のみ可」の"人事"に含めない）
  if (人事経理運行管理者判定(userInfo)) {
    return false
  }

  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    default:
      has社員区分権限 = true
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  return has部所権限 && has社員区分権限
}

/**
 * 有休管理画面の他部所閲覧権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 有休管理画面の他部所閲覧権限判定 = (userInfo: TLoginUserInfo) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限どちらかで許可されている場合、使用可能
  return has部所権限 || has社員区分権限
}

/**
 * 乗務員運行月報の集計実行ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 乗務員運行月報の集計実行ボタンの使用権限判定 = (
  userInfo: TLoginUserInfo
) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック(大川TPのみ利用不可)
  switch (userInfo.部所権限コード) {
    case e部所権限コード.大TP:
      has部所権限 = false
      break
    default:
      has部所権限 = true
      break
  }

  // 社員区分をチェック（全区分で使用可）
  switch (userInfo.社員区分コード) {
    default:
      has社員区分権限 = true
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  return has部所権限 && has社員区分権限
}

/**
 * 人事経理運行管理者判定
 * KAIROS-1116: 部所権限=人事（人事経理） かつ 社員区分=運行部員管理職(区分25) の組合せを判定する。
 * 出勤簿一覧の「他部所・他社員の編集特権を持たせない」対象、および
 * 有給管理画面の「有給付与処理・保有数変更を許可しない」対象の識別に使用する。
 * ※ メニュー権限テーブル(社員区分メニュー/部所権限メニュー)は各次元独立のため、
 *   「部所×区分」の掛け算はフロント側でしか判定できない。
 * ※ 課題では所定時間マスタ(110120)/月次締め処理管理(110800) も対象だったが、
 *   社員区分25 には元々これらのメニュー割当が無く既に非表示（＝修正不可）のため対応不要と判明。
 * @param userInfo
 * @returns true:制限対象
 */
const 人事経理運行管理者判定 = (userInfo: TLoginUserInfo) => {
  return (
    userInfo.部所権限コード === e部所権限コード.人事 &&
    userInfo.社員区分コード === e社員区分.運行部員管理職
  )
}

/**
 * 出勤簿変更可能権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 出勤簿変更可能権限判定 = (userInfo: TLoginUserInfo) => {
  // KAIROS-1116: 人事経理の運行部員管理職(区分25)は他部所・他社員の編集特権を持たず、
  // 一般部所と同様に自分の行のみ編集可とする
  if (人事経理運行管理者判定(userInfo)) {
    return false
  }

  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  // NOTE: 現状は全ケース false（社員区分単独では変更権限を与えない設計）。
  //       ここを true に変える際は KAIROS-1116 の「人事経理×区分25は自分の行のみ編集可」の
  //       前提が崩れないか（上部の早期リターンとの整合）を必ず確認すること。
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = false
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限いずれかを持つ場合、使用可能
  return has部所権限 || has社員区分権限
}

const kengenUtil = {
  車輌異動ボタンの権限判定,
  備品在庫削除ボタンの権限判定,
  有休管理画面の有休付与と変更ボタンの使用権限判定,
  有休管理画面の他部所閲覧権限判定,
  乗務員運行月報の集計実行ボタンの使用権限判定,
  出勤簿変更可能権限判定,
}

export default kengenUtil
